<template>
  <div>
    <div id="ticker" v-if="ticker.length" :class="{ 'pointer-events-none': !clickable }" class="w-window overflow-hidden relative">
      <div v-if="loaded && ticker.length > 1" ref="slider">
        <div v-for="(item, idx) in ticker" :key="idx" class="item">
          <span v-html="item"></span><span class="separator">•</span>
        </div>
      </div>
      <div v-else-if="loaded" class="center">
          <span v-html="ticker[0]"></span>
      </div>
      <ul v-if="!loaded" class="h-9 note-list whitespace-no-wrap absolute top-0 left-0 bg-white">
        ░░░░
      </ul>
    </div>
  </div>
</template>

<script>
import TickerPlaceholder from '@/components/svg/TickerPlaceholder'
import Flickity from 'flickity'

export default {
  name: 'Ticker',
  data () {
    return {
      isDragging: false,
      flkty: null,
      tickerSpeed: 0.4,
      isPaused: false,
      loaded: false,
      clickable: false
    }
  },
  computed: {
    ticker () {
      if (this.$store.state.ticker) {
        return this.$store.state.ticker.items
      } else {
        return false
      }
    }
  },
  methods: {
    start () {
      const el = this.$refs.slider

      if (el) {
        this.flkty = new Flickity(el, {
          autoPlay: false,
          prevNextButtons: false,
          pageDots: false,
          draggable: true,
          wrapAround: true,
          selectedAttraction: 0.015,
          friction: 0.25,
          percentPosition: true,
          setGallerySize: true,
          freeScroll: true,
          cellAlign: 'left'
        })

        this.flkty.on('dragStart', () => {
          this.isDragging = true
          this.isPaused = true
        })
        this.flkty.on('dragEnd', () => {
          setTimeout(() => {
            this.isDragging = false
          }, 10)
        })
        this.flkty.x = 0

        el.addEventListener('mouseenter', this.pause, false)
        el.addEventListener('focusin', this.pause, false)
        el.addEventListener('mouseleave', this.play, false)
        el.addEventListener('focusout', this.play, false)

        this.update()
      }
    },
    update () {
      if (this.isPaused) return
      if (this.flkty.slides) {
        this.flkty.x = (this.flkty.x - this.tickerSpeed) % this.flkty.slideableWidth
        this.flkty.selectedIndex = this.flkty.dragEndRestingSelect()
        this.flkty.updateSelectedSlide()
        this.flkty.settle(this.flkty.x)
      }
      window.requestAnimationFrame(this.update)
    },
    pause () {
      this.isPaused = true
    },
    play () {
      if (this.isPaused) {
        this.isPaused = false
        window.requestAnimationFrame(this.update)
      }
    },
    resize () {
      this.flkty.resize()
    },
    init() {
      this.$nextTick(() => {
        this.loaded = true
        setTimeout(() => {
          this.start()

          this.$nextTick(() => {
            if (this.ticker.length > 1) {
              this.flkty.resize()
            }
          })
        }, 500)
        setTimeout(() => {
          this.clickable = true
        }, 1000)
      })
    }
  },
  mounted () {
    if (!this.ticker) {
      this.$store.dispatch('getTicker')
    } else {
      this.init()
    }
  },
  components: { TickerPlaceholder },
  watch: {
    ticker() {
      this.init()
    }
  }
}
</script>

<style>
#ticker {
  width: full;
  height: 46px;
  background: yellow;
  margin-bottom: 1em;

  @media (--phone) {
    height: 46px;
  }

  p {
    display: inline-block;
    margin-top: 0.75em;
  }

  .item {
    white-space: nowrap;
  }

  .separator {
    display: inline-block;
    padding: 0 1.5em;
  }

  &:hover {
    a {
      text-decoration: underline;
      text-decoration-style: dotted;
    }
  }
}

</style>
